var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.967 6.064a1.001 1.001 0 0 0-.837.414 15.99 15.99 0 0 0 0 19.086 1.005 1.005 0 0 0 1.611-1.197 13.982 13.982 0 0 1-2.77-8.346c0-3.007.974-5.934 2.77-8.348a.999.999 0 0 0-.774-1.609zm24.006 0a1.001 1.001 0 0 0-.74 1.61 13.984 13.984 0 0 1 0 16.693 1.002 1.002 0 0 0 .69 1.595c.356.041.707-.11.922-.398A15.985 15.985 0 0 0 32 16.021c0-3.436-1.103-6.784-3.155-9.543-.2-.278-.53-.434-.872-.414z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.298 9.009c-.33.004-.636.17-.819.443a11.539 11.539 0 0 0-2.047 6.57c0 2.346.71 4.639 2.047 6.568a1.002 1.002 0 1 0 1.646-1.138 9.533 9.533 0 0 1-1.69-5.43c0-1.94.585-3.838 1.69-5.433a.999.999 0 0 0-.827-1.58zm17.343 0a1.001 1.001 0 0 0-.792 1.58 9.544 9.544 0 0 1-.005 10.863 1 1 0 0 0 .737 1.58c.36.028.708-.141.909-.442a11.543 11.543 0 0 0 2.054-6.569c0-2.346-.718-4.639-2.054-6.569a1.001 1.001 0 0 0-.849-.443zm-8.653.252c-3.726 0-6.768 3.039-6.768 6.76 0 3.722 3.042 6.76 6.768 6.76s6.769-3.038 6.769-6.76c0-3.721-3.043-6.76-6.769-6.76z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.988 9.26c-3.726 0-6.768 3.04-6.768 6.761 0 3.722 3.042 6.76 6.768 6.76s6.769-3.038 6.769-6.76c0-3.721-3.043-6.76-6.769-6.76z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/Live.ffc444dd7cffe63be30012fc78004ec8.svg";
export { ForwardRef as ReactComponent };